import { OurService } from "../../model/OurServices";
import { OurServicesRepository } from "../../repositories/Repository";

export class GetOurServicesrUseCase {
    constructor(private ourServicesRepository: OurServicesRepository) {}
  
    async execute(): Promise<OurService[]> {
      return await this.ourServicesRepository.getOurServices();
    }
  }